<template>
  <Modal v-bind="{ redirectOnClose: true }" fullscreen @close="$emit('close')">
    <form
      class="modal max-w-2xl mx-auto min-h-full my-16 flex flex-col"
      slot-scope="{ closeModal }"
      @submit.prevent="applyChanges"
      @click.stop
    >
      <div class="modal__header">
        <h6 class="heading capitalize">
          {{ $te('requirements') ? $t('requirements') : 'requirements' }}
        </h6>
      </div>
      <div class="modal__body flex-1">
        <div v-if="edit" class="space-y-8">
          <div class="space-y-2">
            <textarea
              id="requirements"
              ref="requirements"
              v-model="requirements"
              :disabled="updating"
              name="requirements"
              class="input"
              rows="15"
              @blur="edit = false"
            />
          </div>
        </div>

        <div v-else>
          <div
            class="-m-2 p-2 leading-normal rounded hover:bg-gray-300"
            v-html="mdRequirements"
            @click="doEdit"
          />
        </div>
      </div>
      <div class="modal__body">
        <div class="space-x-2 text-right">
          <button
            type="button"
            :disabled="updating"
            class="btn btn-brand style-link px-6 capitalize"
            @click="closeModal"
          >
            {{ $te('cancel') ? $t('cancel') : 'cancel' }}
          </button>
          <button :disabled="updating" class="btn btn-brand px-6 capitalize">
            {{ $te('update') ? $t('update') : 'update' }}
          </button>
        </div>
      </div>
    </form>
  </Modal>
</template>

<script>
import { marked } from 'marked';
import Modal from '@/components/Ui/Modal.vue';

const renderer = new marked.Renderer();
renderer.list = (body, ordered) => {
  if (ordered) {
    return `<ol class="list-decimal list-inside">${body}</ol>`;
  }
  return `<ul class="list-disc list-inside">${body}</ul>`;
};

export default {
  name: 'RequirementsModal',
  components: {
    Modal,
  },
  props: {
    updating: Boolean,
    packageItem: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    requirements: '',
    edit: false,
  }),
  computed: {
    mdRequirements() {
      if (!this.requirements) return 'Add requirements';
      return marked(this.requirements, { renderer });
    },
  },
  mounted() {
    const { requirements = '' } = this.packageItem || {};
    this.requirements = requirements;
  },
  methods: {
    doEdit() {
      if (this.disabled) return;
      this.edit = true;
    },
    applyChanges() {
      this.$emit('submit', { requirements: this.requirements });
    },
  },
};
</script>
